export default "__VITE_ASSET__BT53qViq__"